<template src="./pending-schedule.html">
</template>
<script>
import mixins from "../../../../mixins/mixins.js";
export default {
  mixins: [mixins],
  data() {
    return {
      appointments: [],
    }
  },
  mounted() {
    const vm = this;
    if (vm.testNullUndefinedEmpty(vm.$session.get("idCompany")) === false) {
      vm.idCompany = vm.$session.get("idCompany");
      vm.getPendingSchedule();
    }
  },
  methods: {
    getPendingSchedule(){
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "company/consultas-solicitadas/" + vm.idCompany ,
          {
            headers: { Authorization: vm.$session.get("bearer") },
          }
        )
        .then(function(response) {
          if (response.status === 200) {
            vm.appointments = response.data;
          }
        })
        .catch(function(error) {
          console.log({error: error});
        });
    },
  },
}
</script>

<style lang="scss" src="./pending-schedule.scss">

</style>